import angular from 'angular';
import booksMenu from '../../menu/Menu';
import ngRoute from 'angular-route';
/** Services */
import { DepositHistoryService } from './services/DepositHistoryService';
/** Routes */
import { depositListComponent } from './routes/main/depositList';
import { PrintDepositService } from './routes/viewDeposit/printDeposit';
import { viewDepositComponent } from './routes/viewDeposit/viewDeposit';
import { listColumnDirective } from './routes/viewDeposit/viewDeposit';
import './depositHistory.scss';

export default angular
  .module('depositHistory', [
    booksMenu,
    ngRoute,
    'ui.grid',
    'ui.grid.autoResize',
    'ui.grid.resizeColumns',
    'ui.grid.pinning',
    'ui.grid.grouping',
    'ui.grid.saveState'
  ])
  .controller('depositHistoryRoutesController', RouteController)
  .config(ConfigRoutes)
  .run(runInit)
  .service('DepositHistoryService', DepositHistoryService)
  .component('depositList', depositListComponent)
  .service('PrintDeposit', PrintDepositService)
  .component('viewDeposit', viewDepositComponent)
  .directive('listColumn', listColumnDirective).name;

/*******************************************************************************
 * Config: ConfigRoutes */
/**
 * @ngdoc  config
 * @module depositHistory
 * @name   depositHistory.config:ConfigRoutes
 * @description
 * Sets up the route provider with the following routes.
 * /                The main screen when you first load the application.
 * /view/:id  {id}  This is the detail deposit screen.
 *******************************************************************************/
/* @ngInject */ function ConfigRoutes($routeProvider) {
  $routeProvider
    .when('/', {
      template:
        '<deposit-list is-boosterpta = "isBoosterpta" account-name = "accountName"></deposit-list>'
    })
    .when('/view/:id', {
      template:
        '<view-deposit is-boosterpta = "isBoosterpta" account-name = "accountName"></view-deposit>'
    })
    .otherwise('/');
}

/*******************************************************************************
 * Run: runInit */
/**
 * @ngdoc  run
 * @module depositHistory
 * @name   depositHistoryRoutesController.run:runInit
 * @description
 * Setup the routes to redirect to the root if there are any errors during the
 * route change.
 *******************************************************************************/
/* @ngInject */ function runInit($rootScope, $location) {
  /*--------------------------------------*/
  /* Redirect to the root on route error. */
  /*--------------------------------------*/
  $rootScope.$on('$routeChangeError', function () {
    $location.url('/');
  });
}

/*******************************************************************************
 * Controller: RouteController */
/**
 * @ngdoc  controller
 * @module depositHistory
 * @name   depositHistory.controller:DepositListController
 * @description
 * Controller for the application. While this controller doesn't do anything
 * special directly, we still need a controller to be set as the books-controller
 * in the page.
 *******************************************************************************/
/* @ngInject */ function RouteController($scope, SERVER) {
  $scope.isBoosterpta =
    SERVER.productID == 'PTAEZ' || SERVER.productID == 'Booster Finance';

  $scope.accountName = $scope.isBoosterpta ? 'Category Name' : 'Account Name';
}
